import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import api from '@/images/api.gif';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <div>
      <h2>{`API Quickstart Guide`}</h2>
      <img alt="" src={api} width={860} />
      <p>{`Welcome to GIPHY API, where you can seamlessly integrate your app with the largest GIF and Sticker library in the world.`}</p>
      <p>{`GIPHY API is simple and fast to use, but if you're looking for something with automatic updates and access to exclusive features, our SDK might be an even better fit for you — `}<a href="/docs/sdk">{`check out GIPHY SDK!`}</a></p>
      <h2>{`Quickstart`}</h2>
      <p>{`The following guide will walk you through the minimum viable GIPHY API integration for a seamless GIPHY experience in your app. If you have any questions, email us at `}<a href="mailto:developers@giphy.com"><a parentName="p" {...{
            "href": "mailto:developers@giphy.com"
          }}>{`developers@giphy.com`}</a></a>{`.`}</p>
      <h3>{`Apply for an API Key(s)`}</h3>
      <p>
  <ol style={{
          "listStyle": "decimal",
          "listStylePosition": "inside"
        }}>
    <li style={{
            "marginLeft": "30px"
          }}>
      <strong>Create a GIPHY API Key</strong> by clicking “Create an App” on the <a href="/dashboard/">Developer Dashboard</a> (you need to create an account first).
      <br />
      Note: All API Keys start as beta keys, which are rate limited (42 reads per hour and 1000 searches/API calls per day.)
    </li>
    <li style={{
            "marginLeft": "30px"
          }}>
      <strong>Create separate keys for each platform (iOS, Android, Web) and section.</strong> If you’re using a GIPHY integration in different sections of your app, GIPHY requires
      that each use of our service be delineated by a different key for each section per platform.
    </li>
  </ol>
      </p>
      <h3>{`Implement Necessary API Endpoints`}</h3>
      <p>{`The GIPHY experience is brought to life with two essential endpoints: Trending and Search.`}</p>
      <p>
  The <a href="/docs/api/endpoint#trending">Trending endpoint</a> automatically populates the most relevant and engaging content each and every day, while the{' '}
  <a href="/docs/api/endpoint/#search">Search endpoint</a> lets users search our library of millions of GIFs and Stickers by entering a word or phrase.
      </p>
      <h3>{`Best Practices for Renditions`}</h3>
      <p>
  <ol style={{
          "listStyle": "decimal",
          "listStylePosition": "inside"
        }}>
    <li style={{
            "marginLeft": "30px"
          }}>
      Every GIF returned by the Trending and Search endpoints contains an <span style={{
              "fontFamily": "'PT Mono'"
            }}>images</span> object with Media URLs (
      <span style={{
              "fontFamily": "'PT Mono'"
            }}>url</span> field). The <span style={{
              "fontFamily": "'PT Mono'"
            }}>images</span> object returns multiple renditions.
    </li>
    <li style={{
            "marginLeft": "30px"
          }}>
      We provide various renditions of each GIF in the <span style={{
              "fontFamily": "'PT Mono'"
            }}>images</span> object to give your users the best experience possible. Generally, it’s
      best to use the smaller fixed_height or fixed_width renditions on your preview grid.
    </li>
    <li style={{
            "marginLeft": "30px"
          }}>Once a user has selected a GIF, present a higher resolution rendition.</li>
    <li style={{
            "marginLeft": "30px"
          }}>If you have bandwidth limitations consider using downsized_small(max 200kB), downsized (max 2MB), downsized_medium(max 5MB) renditions.</li>
    <li style={{
            "marginLeft": "30px"
          }}>
      Refer to our <a href="/docs/optional-settings#rendition-guide">Rendition Guide</a> for more information on what rendition is best suited for each use-case.{' '}
    </li>
  </ol>
      </p>
      <h3>{`Upgrade API Key(s) to Production Level`}</h3>
      <p>
  <ol style={{
          "listStyle": "decimal",
          "listStylePosition": "inside"
        }}>
    <li style={{
            "marginLeft": "30px"
          }}>Once your app is QA complete and close to going live, it’s time to upgrade your API key(s) to Production Level.</li>
    <li style={{
            "marginLeft": "30px"
          }}>
      In the <a href="/dashboard/">Developer Dashboard</a>, click the “Upgrade to Production” button for eachAPI key used in your app and complete the instructions that follow.
    </li>
  </ol>
      </p>
      <h3>{`Incorporate Analytics`}</h3>
      <p>{`GIPHY uses GIPHY Analytics to improve search results for your users. By calling our `}<a href="/docs/api/endpoint#action-register">{`Action Register Endpoint`}</a>{` each time a user views, clicks, or sends a GIF or Sticker, we will be able to customize our responses to your user's behavior. We highly recommend calling this endpoint on every user action in your app.`}</p>
      <p>{`To add analytics to your app, head to our `}<a href="/docs/api/endpoint#action-register">{`Action Register Endpoint`}</a>{`.`}</p>
      <h2>{`Attribution`}</h2>
      <p>{`We require all apps that use GIPHY API to conspicuously display `}<strong parentName="p">{`"Powered By GIPHY"`}</strong>{` attribution marks where the API is utilized (see SDK attribution guide `}<a href="/docs/sdk#design-guidelines">{`here`}</a>{`). You can find approved `}<a parentName="p" {...{
          "href": "https://giphymedia.s3.amazonaws.com/giphy-attribution-marks.zip"
        }}>{`official logo marks here`}</a>{`.`}</p>
      <p><em parentName="p">{`Before getting started with GIPHY API, please take a look at our `}<a parentName="em" {...{
            "href": "https://support.giphy.com/hc/en-us/articles/360028134111-GIPHY-API-Terms-of-Service-"
          }}>{`API Terms of Service.`}</a>{`. If you currently are using GIPHY API, then the `}<a parentName="em" {...{
            "href": "https://support.giphy.com/hc/en-us/articles/360028134111-GIPHY-API-Terms-of-Service-"
          }}>{`API Terms of Service`}</a>{` apply.`}</em></p>
    </div>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      